import {
    ActionIcon,
    Avatar,
    Box,
    Button,
    Flex,
    Indicator,
    MediaQuery,
    Menu,
    Text,
} from "@mantine/core";
import { useSession, signIn, signOut } from "next-auth/react";
import {
    IconSettings,
    IconSearch,
    IconPhoto,
    IconMessageCircle,
    IconTrash,
    IconArrowsLeftRight,
    IconLogout,
    IconReportAnalytics,
    IconBrandGoogleAnalytics,
    IconLogin,
    IconCheck,
    IconPlus,
    IconUserCheck,
    IconBellRinging,
    IconChevronDown,
    IconAccessible,
    IconAffiliate,
    IconUser,
    IconQuestionMark,
} from "@tabler/icons";
import Link from "next/link";
import { useRouter } from "next/router";
import { showNotification, updateNotification } from "@mantine/notifications";
import { Fragment, useState } from "react";
import ProfilePicture from "./ProfilePicture";

function LoginButton() {
    const { data: session, status } = useSession();
    const router = useRouter();

    const [loading, setLoading] = useState(false);

    // console.log(session);
    if (session) {
        return (
            <Box>
                {/* Signed in as {session.user.email} <br /> */}
                <Menu
                    trigger="hover"
                    transition="scale"
                    closeDelay={400}
                    shadow="md"
                    width={200}
                >
                    <Menu.Target>
                        {/* <Button>Account</Button> */}

                        <Flex gap={0} direction={"column"} justify={"start"}>
                            <ActionIcon>
                                <ProfilePicture
                                    {...{
                                        image: session.user.image,
                                        name: session.user.name,
                                    }}
                                />
                            </ActionIcon>
                            <ActionIcon sx={{ alignSelf: "end" }}>
                                <IconChevronDown size={18} />
                            </ActionIcon>
                        </Flex>
                    </Menu.Target>

                    <Menu.Dropdown>
                        {!!session && session.info.usertype == "admin" && (
                            <Menu.Item
                                icon={<IconUserCheck size={14} />}
                                onClick={() => {
                                    router.push("/admin/add");
                                }}
                            >
                                <Text>Admin section</Text>
                            </Menu.Item>
                        )}

                        <Menu.Item
                            icon={<IconQuestionMark size={14} />}
                            onClick={() => {
                                router.push("/doubts");
                            }}
                        >
                            <Text>Ask doubts</Text>
                        </Menu.Item>

                        <Menu.Item
                            icon={<IconBrandGoogleAnalytics size={14} />}
                            onClick={() => {
                                router.push("/testanalytics");
                            }}
                        >
                            <Text>Performance report</Text>
                        </Menu.Item>

                        <Menu.Item
                            onClick={() => {
                                showNotification({
                                    id: "logout_click",
                                    title: "Logging you out",
                                    message:
                                        "Clearing session data, please wait!",
                                    loading: true,
                                });
                                setTimeout(() => {
                                    // signout after 1 second
                                    signOut().then(() => {
                                        updateNotification({
                                            id: "logout_click",
                                            title: "You are logged out",
                                            color: "teal",
                                            message:
                                                "Notification will close in 2 seconds, you can close this notification now",
                                            icon: <IconCheck size={16} />,
                                            autoClose: 2000,
                                        });
                                        // after signout go to dashboard
                                        router.push("/");
                                    });
                                }, 2000);
                            }}
                            color="red"
                            icon={<IconLogout size={14} />}
                        >
                            Log Out
                        </Menu.Item>
                    </Menu.Dropdown>
                </Menu>
                {/* <Button onClick={() => signOut()}>Sign out</Button> */}
            </Box>
        );
    }
    return (
        <Box>
            {/* Not signed in <br /> */}
            <MediaQuery
                smallerThan={"md"}
                styles={{
                    display: "none",
                }}
            >
                <Button
                    color="indigo"
                    rightIcon={<IconLogin />}
                    loading={loading}
                    loaderPosition={"right"}
                    onClick={() => {
                        setLoading(true);
                        signIn();
                    }}
                >
                    Sign In/Up
                </Button>
            </MediaQuery>
            <MediaQuery
                largerThan={"md"}
                styles={{
                    display: "none",
                }}
            >
                <Box>
                    <Button
                        px={"xs"}
                        variant="outline"
                        color="green"
                        loading={loading}
                        onClick={() => {
                            setLoading(true);
                            signIn();
                        }}
                    >
                        Login
                    </Button>
                    <Text c={"dimmed"} fz={"xs"} ta={"center"}>
                        or SignUp
                    </Text>
                </Box>
            </MediaQuery>
        </Box>
    );
}

export default LoginButton;
